import requestAction from '../../utils/requestAction'

export const fetchDays = () => 
  requestAction('NON_SCHOOL_DAY_LIST')('non-school-days', 'GET')
